import type { ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { useClinicalTrialsAdminAccess } from "../hooks/useClinicalTrialsAdminAccess";
import { CLIENT_LANDING_PATH } from "./SuperAdminRoute";

/** Restrict Notes and patient summaries to CT admins and system superadmins. */
export function ClinicalTrialsAdminRoute({
  children,
}: {
  children: ReactElement;
}) {
  const canAccess = useClinicalTrialsAdminAccess();
  return canAccess ? children : <Navigate to={CLIENT_LANDING_PATH} replace />;
}
